import Vue from "vue";
import VueRouter, { RouteConfig, RawLocation } from "vue-router";
import { Component } from "vue-property-decorator";
import { getUrlParams } from "@wj/common";
import pageRoutePC from "./pagePC";
import pageRoute from "./page";
const layout = () => import("@/views/page/layout.vue");
const newLayout = () => import("@/views/page/newLayout.vue");
const login = () => import("../views/page/h5/login.vue");
const loginPC = () => import("@/views/page/pc-login/index.vue");
Vue.use(VueRouter);

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation) {
  return (originalPush.call(this, location) as any).catch((e: any) => {
    e;
  });
};

const routes: Array<RouteConfig> = [
  {
    //PC端
    path: "/views",
    component: newLayout,
    children: pageRoutePC,
  },
  //手机端
  {
    path: "/pages",
    component: layout,
    children: pageRoute,
  },
  {
    path: "/login",
    component: login,
  },
  {
    path: "/loginPC",
    component: loginPC,
  },
  {
    path: "/",
    redirect: "/pages/home",
  },
  {
    path: "*",
    redirect: "/pages/home",
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const { fullPath } = to;
  // let token = localStorage.getItem('token');
  // if (token) {
  // 	next();
  // } else {
  // 	if (to.path == '/login' || to.path == '/pages/home') {
  // 		next();
  // 	} else {
  // 		next('/login');
  // 	}
  // }
  next();
});
// router.beforeEach((to, from, next) => {
// 	const { fullPath } = to;
// 	let token = fullPath.split("token=")[1];
// 	if (token) {
// 		localStorage.setItem('token', token);
// 	}
// 	next();
// })
export default router;
